import React from 'react';
import Icon from './Icon';

const RailroadIcon = (props) => (
    <Icon {...props}>
        <path
            d="M7 2V22M17 2V22M4 4.5H20M4 9.5H20M4 14.5H20M4 19.5H20"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default RailroadIcon;
